import {observer} from 'mobx-react-lite'
import React from 'react'
import {DataObjectId} from 'yougile-model'
import {TwHistoryListContainer} from './containers'
import {useGetPreparedUsers} from './hooks/use-get-prepared-users'
import {TaskDescriptionHistoryItem} from './task-description-history-item'
import {useTaskDescription} from './task-description-store'

export const TaskDescriptionHistoryList = observer(() => {
  const [state] = useTaskDescription()
  const users = useGetPreparedUsers()

  return (
    <TwHistoryListContainer>
      {state.historyList?.map((item, index, arr) => (
        <TaskDescriptionHistoryItem
          key={index}
          userId={item.userId as DataObjectId}
          date={item.date}
          prevUserId={arr[index - 1]?.userId}
          usersMap={users}
        />
      ))}
    </TwHistoryListContainer>
  )
})
